import React from "react";
import { Component } from "react";
import "../cost-report/cost-report-line-chart/cost-report-line-chart.component.css";
import { ChartHeaderDropdown } from "../../../common/data-header/chart-header-dropdown.component";
export class CsatTotalComp extends Component {
    render() {     

      const data=[{
            headerName:"Count of Released Survey",
            total:123 
        }, {
            headerName:"Total No. of Respondents",
            total:485
        },{
            headerName:"Response Rate",
            total:'80%'
        },{
            headerName:"Overall CSAT Score",
            total:4.59
        }]

        return(
            <div className="table-chart-4">
                {data.map((item,id)=>
                    <div className="component-container table-4" key={id}>
                        <ChartHeaderDropdown haveOneIcone={true} haveIconInfo={true} iconInfo="info-circle-solid" haveLedger={false} headerName={item.headerName} circleIcon={false} circleFirstIcon="list-regular" circleSecondIcon="th-solid" oneIcon="vertical-grid" 
                          haveInput={false} haveDropdown={false} displayValue={item.total}  />  
                    </div>
                )}                
            </div>
        )
    }
}